<template>
  <h1>Track parcel</h1>
</template>

<script setup lang="ts"></script>
